<p-steps [(activeIndex)]="activeIndex" [readonly]="false" [model]="items"></p-steps>